import { ReactNode } from "react";

import { Navigate } from "react-router";

import { useAuth } from "../context/Auth/AuthProvider";
import { USER_PERMISSIONS } from "../roles/types/enums";
import { NAVIGATION_ITEMS, ROUTES } from "../shared";
import { useReleaseFeatureToggle } from "../shared/featureToggles/hooks";
import { FEATURE_NAMES } from "../shared/featureToggles/types";
import { isItemVisible } from "../shared/layout";

interface RestrictedRouteProps {
  children: ReactNode;
  itemName: NAVIGATION_ITEMS;
}

const RestrictedRoute = ({ children, itemName }: RestrictedRouteProps) => {
  const { getAccessStatus, user } = useAuth();
  const { isReleaseFeatureEnabledForRole } = useReleaseFeatureToggle();

  const hiddenRoutesForUsers: { [key: string]: USER_PERMISSIONS } = {
    [NAVIGATION_ITEMS.Users]: USER_PERMISSIONS.ManageUsers,
    [NAVIGATION_ITEMS.Companies]: USER_PERMISSIONS.SeeCompanyHierarchy
  };
  const isAllowedToSeeDashboard = isReleaseFeatureEnabledForRole(
    FEATURE_NAMES.ShowDashboard,
    user?.role
  );

  const checkIfUserCanAccessRoute = () => {
    if (itemName in hiddenRoutesForUsers) {
      return getAccessStatus(hiddenRoutesForUsers[itemName]);
    }
    return true;
  };

  const isAllowed = () => {
    if (
      isItemVisible(itemName, isAllowedToSeeDashboard) &&
      checkIfUserCanAccessRoute()
    ) {
      return children;
    }
    return isItemVisible(
      NAVIGATION_ITEMS.Dashboard,
      isAllowedToSeeDashboard
    ) ? (
      <Navigate to={ROUTES.Dashboard} replace />
    ) : (
      <Navigate to={ROUTES.Vehicles} replace />
    );
  };

  return <>{isAllowed()}</>;
};

export default RestrictedRoute;
